export default [
  //********需求单******** */ 
  // POST /obt/tkNeedOrderCancel
  // 国际机票需求单忽略接口
  {
    name: 'tkNeedOrderCancel',
    method: 'post',
    desc: '国际机票需求单忽略接口',
    path: '/obt/tkNeedOrderCancel',
    params: {
      'orderFrom': '',
      'orderId': ''
    }
  },
  // POST /obt/tkNeedOrderDetail
  // 机票需求单详情
  {
    name: 'tkNeedOrderDetail',
    method: 'post',
    desc: '机票需求单详情',
    path: '/obt/tkNeedOrderDetail',
    params: {
      'orderId': ''
    }
  },
  // POST /obt/tkNeedOrderList
  // 机票需求单列表
  {
    name: 'tkNeedOrderList',
    method: 'post',
    desc: '机票需求单列表',
    path: '/obt/tkNeedOrderList',
    params: {
      'count': 0,
      'dateEnd': '',
      'dateStart': '',
      'pageNum': 0
    }
  },
  // POST /obt/tkNeedOrderUpdate
  // 修改机票需求单
  {
    name: 'tkNeedOrderUpdate',
    method: 'post',
    desc: '修改机票需求单',
    path: '/obt/tkNeedOrderUpdate',
    params: {
      'orderId': '',
      'productType': ''
    }
  },
]
